<style lang="scss">
  .ask-ai-button {
    display: flex;
    flex-shrink: 0;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { activeTabStore } from "../stores";

  const onclick = () => {
    activeTabStore.set("askAiTab");
  };
</script>

{#if $activeTabStore !== "askAiTab"}
  <div class="ask-ai-button">
    <Button
      leadingIcon="fa-regular fa-sparkles"
      kind="ai-emphasis"
      {onclick}
      style="width: 100%"
    >
      Ask AI
    </Button>
  </div>
{/if}
